
  export const peopleViewRoutes = {
    people: '/admin/people-views/:itemIdd',

  };
  